import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "preview-list el-upload-list el-upload-list--picture-card"
}

import { ref, getCurrentInstance, watch } from 'vue'
import { useStore } from '@/store/index'
import { AppActionTypes } from '@/store/modules/app/action-types'
import { Plus, Delete } from '@element-plus/icons-vue'
    

export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  props: {
    type: {
        type: String,
        default: 'image'
    },
    preview: {
        type: Boolean,
        default: true
    },
    previewList: {
        type: Array,
        default: () => []
    },
    accept: {
        type: String,
        default: 'image/png,image/jpg,image/jpeg'
    },
    action: {
        type: String,
        default: '/api/cake/setSpecsImg?x-oss-process=style/specs&oss_file='
    },
    folderName: {
        type: String,
        default: 'others'
    },
    listType: {
        type: String,
        default: 'picture-card'
    },
    showFileList: {
        type: Boolean,
        default: false
    },
    maxCount: {
        type: Number,
        default: 1
    },
    size: {
        type: Number,
        default: 0
    },
    modelValue: {
        type: [String, Array],
        default: () => []
    }
},
  emits: ['uploadSuccess', 'remove', 'update:modelValue'],
  setup(__props, { emit: __emit }) {

const store = useStore()
const proxy = getCurrentInstance() as any
const emits = __emit
const props = __props

const previewList = ref(
    props.modelValue
        ? (Array.isArray(props.modelValue) ? [...props.modelValue] : [props.modelValue as string])
        : (Array.isArray(props.previewList) ? [...props.previewList] : [])
)

// Watch for changes in modelValue prop and update previewList accordingly
watch(() => props.modelValue, (newValue) => {
    previewList.value = Array.isArray(newValue) ? [...newValue] : (newValue ? [newValue] : [])
}, { deep: true })

// 上传前校验
const onBeforeUpload = (file) => {
    const { size } = props
    if (size && (file.size > 1024 * 1024 * size)) {
        proxy.$message({ type: 'error', message: `图片须小于 ${ size } M` })
        return false
    }
    store.dispatch(AppActionTypes.ACTION_SET_GLOBALLOADING, true)
    // emits('pageChange', pageOptions.page)
}
// 上传成功回调
const uploadSuccess = (res) => {
    store.dispatch(AppActionTypes.ACTION_SET_GLOBALLOADING, false)
    const { code, data, msg } = res
    if (code != 200) return proxy.$message({ type: 'success', message: msg })
    if (props.maxCount === 1) {
        previewList.value = [data.img_info.o_path]
    } else {
        previewList.value.push(data.img_info.o_path)
    }
    // Emit the updated list to bind to the parent component
    if (props.maxCount === 1) {
        // For single image upload
        emits('update:modelValue', data.img_info.o_path)
    } else {
        // For multiple image upload
        emits('update:modelValue', [...previewList.value])
    }
    emits('uploadSuccess', data)
}
// 删除某一项
const onRemove = (index) => {
    previewList.value.splice(index, 1)
    if (props.maxCount === 1) {
        // For single image upload
        emits('update:modelValue', previewList.value[0] || '')
    } else {
        // For multiple image upload
        emits('update:modelValue', [...previewList.value])
    }
    emits('remove', index)
}

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_button = _resolveComponent("el-button")!

  return (__props.type === 'image' && __props.preview)
    ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(previewList.value, (item, index) => {
          return (_openBlock(), _createElementBlock("li", {
            class: "preview-item el-upload-list__item",
            key: index
          }, [
            _createVNode(_component_el_image, {
              src: item,
              "preview-src-list": previewList.value,
              "initial-index": index,
              "hide-on-click-modal": "",
              "append-to-body": "",
              "z-index": 3000
            }, null, 8, ["src", "preview-src-list", "initial-index"]),
            _createVNode(_component_el_icon, {
              class: "icon",
              onClick: ($event: any) => (onRemove(index))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Delete))
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]))
        }), 128)),
        _withDirectives(_createVNode(_component_el_upload, {
          class: "el-upload-list__item empty-item",
          ref: "uploadRef",
          accept: __props.accept,
          action: `${__props.action}${__props.folderName}`,
          "before-upload": onBeforeUpload,
          "on-success": uploadSuccess,
          "list-type": __props.listType,
          "show-file-list": __props.showFileList
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_unref(Plus))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["accept", "action", "list-type", "show-file-list"]), [
          [_vShow, previewList.value.length == 0]
        ])
      ]))
    : (_openBlock(), _createBlock(_component_el_upload, {
        key: 1,
        class: "avatar-uploader",
        ref: "uploadRef",
        accept: __props.accept,
        action: `${__props.action}${__props.folderName}`,
        "before-upload": onBeforeUpload,
        "on-success": uploadSuccess,
        "list-type": __props.listType,
        "show-file-list": __props.showFileList
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, { type: "primary" }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createTextVNode("点击上传")
            ])),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["accept", "action", "list-type", "show-file-list"]))
}
}

})